import React from 'react';
import { motion } from 'framer-motion';
import Subfolder from './Subfolder';
import NextChapterButton from './NextChapterButton';
import { useTheme } from '../contexts/ThemeContext';

const FolderContent = ({ folder, folderIndex, completedLessons, toggleComplete, isSubfolderUnlocked, onNextChapter, courseData }) => {
  const { isDarkMode } = useTheme();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className="animate-fadeIn"
    >
      <motion.h2 
        className={`text-2xl md:text-3xl font-bold mb-6 pb-3 border-b-4 border-primary-600 transition-colors duration-300 ${
          isDarkMode ? 'text-white' : 'text-gray-700'
        }`}
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        {folder.title}
      </motion.h2>
      
      <div className="space-y-6">
        {folder.subfolders.map((subfolder, subfolderIndex) => (
          <motion.div
            key={subfolder.id}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: subfolderIndex * 0.1 + 0.3 }}
          >
            <Subfolder
              subfolder={subfolder}
              folderIndex={folderIndex}
              subfolderIndex={subfolderIndex}
              completedLessons={completedLessons}
              toggleComplete={toggleComplete}
              isUnlocked={isSubfolderUnlocked(folderIndex, subfolderIndex)}
            />
          </motion.div>
        ))}
        
        <NextChapterButton
          folder={folder}
          folderIndex={folderIndex}
          completedLessons={completedLessons}
          onNextChapter={onNextChapter}
          courseData={courseData}
        />
      </div>
    </motion.div>
  );
};

export default FolderContent;